<div class="container">
    <div class="row" style="    padding-bottom: 20px;">
        <div>
            <div>
                <h1>Payment Method</h1>
            </div>
            <div class="first-div">
                <div class="main-div">
                    <div>
                        <h4 class="first-h">Select Card</h4>
                    </div>
                    <div class="plus-icon">
                        <div><img src="../../../../../assets/image/circle-plus (2).svg" alt="invalid" /></div>
                        <button class="second-h" (click)="addCard()">Add Card</button>

                    </div>

                </div>
                <div>
                    <div class="visa-icon" *ngFor="let card of cardsList">
                        <div style="display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        align-items: center;">
                            <span style="font-size:28px">{{card?.brand}}</span>
                            <!-- <img class="visa-img"
                                [src]="card?.brand =='Visa' ? '../../../../../assets/icons/image 66.png' : '../../../../../assets/icons/image 66.png'" /> -->
                            <span>
                                &nbsp;• • • • &nbsp; • • • • &nbsp; • • • • &nbsp; {{card?.card}}
                            </span>
                        </div>
                        <div class="cvv">
                            <div class="cvv-enter">
                                <input style="display: none;" placeholder="CVC" class="number-input"
                                    (keyup)="pressCvv(card.id)" (change)="checkCvcChar(card.id)" (keypress)="numberOnly($event)" id="cvvText{{card.id}}" type="password" maxlength="3" />
                            </div>
                            <div class="customCheckbox" style="transform: translate(0px, 2px);">
                                <input type="checkbox" id="checkbox{{card.id}}" class="largerCheckbox"
                                    (change)="cardSelect($event,card)" />
                            </div>
                        </div>

                    </div>
                    <!-- <div class="visa-icon">
                        <div><img class="visa-img" src="../../../../../assets/icons/image 66.png" /><span>• • • • • • •
                                • • • • •
                                3123</span>
                        </div>
                        <div class="cvv">
                            <div class="cvv-enter"><input class="number-input" type="text" /></div>
                            <div><input type="checkbox" class="largerCheckbox" /></div>
                        </div>

                    </div> -->
                </div>
            </div>
            <div class="place-order" *ngIf="!requestId && !orderId">
                <button class="sub-btn" type="submit" (click)="placeOrder()"
                    [disabled]="!cardId || !cvv || cvv.length<3 && (!paynowId ||!requestData ||!cvv || cvv.length<3)">Place Order</button>
            </div>

            <div class="place-order" *ngIf="requestId && orderId">
                <button class="sub-btn" type="submit" (click)="payNowRequest()"
                    [disabled]="!cardId || !cvv || cvv.length<3">Place Order</button>
            </div>
        </div>
    </div>

</div>